enum Status {
  not_migrated = 'not_migrated',
  without_access = 'without_access',
}

export default Status;